import { get, writable } from 'svelte/store'

function createMarketLibraryStorePhy() {
  const { subscribe, set, update } = writable({
    surveys: [],
    modules: [],
    blends: [],
    uploads: [],
    shared_with_me: [],
    loading: false,
    query: null,
  })

  return {
    subscribe,
    set,
    update,
    getMarketLibraryListPhy: () => {
      const list = get(marketLibraryStorePhy)
      list.surveys = sortArrayByRowOrder(list.surveys)
      list.modules = sortArrayByRowOrder(list.modules)
      list.uploads = sortArrayByRowOrder(list.uploads)
      return list
    },
    refetch: () => {
      const store = get(marketLibraryStorePhy)
      if (store.query) {
        store.query()
      }
    },
  }
}

function createMarketLibraryManageDataStorePhy() {
  const { subscribe, set, update } = writable({
    surveys: [],
    modules: [],
    blends: [],
    uploads: [],
    shared_with_me: [],
    loading: false,
    query: null,
  })

  return {
    subscribe,
    set,
    update,
    getMarketLibraryManageDataListPhy: () => {
      const list = get(marketLibraryManageDataStorePhy)
      list.surveys = sortArrayByRowOrder(list.surveys)
      list.modules = sortArrayByRowOrder(list.modules)
      list.uploads = sortArrayByRowOrder(list.uploads)
      return list
    },
    refetch: () => {
      const store = get(marketLibraryManageDataStorePhy)
      if (store.query) {
        store.query()
      }
    },
  }
}
function sortArrayByRowOrder(array) {
  return array?.sort((a, b) => a.row_order - b.row_order) || []
}

export const marketLibraryStorePhy = createMarketLibraryStorePhy()
export const marketLibraryManageDataStorePhy = createMarketLibraryManageDataStorePhy()

function createMarketLibraryStoreApp() {
  const { subscribe, set, update } = writable({
    surveys: [],
    modules: [],
    blends: [],
    uploads: [],
    shared_with_me: [],
    loading: false,
    query: null,
  })

  return {
    subscribe,
    set,
    update,
    getMarketLibraryListApp: () => {
      const list = get(marketLibraryStoreApp)
      list.surveys = sortArrayByRowOrder(list.surveys)
      list.modules = sortArrayByRowOrder(list.modules)
      list.uploads = sortArrayByRowOrder(list.uploads)
      return list
    },
    refetch: () => {
      const store = get(marketLibraryStoreApp)
      if (store.query) {
        store.query()
      }
    },
  }
}
function createMarketLibraryManageDataStoreApp() {
  const { subscribe, set, update } = writable({
    surveys: [],
    modules: [],
    blends: [],
    uploads: [],
    shared_with_me: [],
    loading: false,
    query: null,
  })

  return {
    subscribe,
    set,
    update,
    getMarketLibraryManageDataListApp: () => {
      const list = get(marketLibraryManageDataStoreApp)
      list.surveys = sortArrayByRowOrder(list.surveys)
      list.modules = sortArrayByRowOrder(list.modules)
      list.uploads = sortArrayByRowOrder(list.uploads)
      return list
    },
    refetch: () => {
      const store = get(marketLibraryManageDataStoreApp)
      if (store.query) {
        store.query()
      }
    },
  }
}
export const marketLibraryStoreApp = createMarketLibraryStoreApp()
export const marketLibraryManageDataStoreApp = createMarketLibraryManageDataStoreApp()
